import { FamilyApplication } from '@/queries/family_applications/requests'

export function getDisplayedStudentStatus(
  student: Pick<
    FamilyApplication,
    'status' | 'is_funded_current_term' | 'is_preview_awarded_current_term'
  >
): FamilyApplication['status'] {
  if (student.status === 'Eligible' && student.is_funded_current_term) {
    return 'Funded'
  }
  if (
    student.status === 'Eligible' &&
    student.is_preview_awarded_current_term
  ) {
    return 'Awarded'
  }
  return student.status
}
